import MainStore from "@/store";
import MainRouter from "@/router";

import localStore from "./store";
import localRoutes from "./router";

MainStore.registerModule("auth", localStore);
MainRouter.addRoutes(localRoutes);
